require('./../css/style.css');

export default {}


// WEBPACK FOOTER //
// ./uPortal/Core/Panels/RTStartPanel/Js/index.js